import { app } from '../../../../../app';
import { Controller } from './basic.controller';

app.component('userProfileBasic', {
    bindings: {profile: '<'},
    controller: Controller,
    templateUrl: require('./basic.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/profiles/profile/basic/basic.component.js